import { Sparkles, Code2, Coins, Flag } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

const ICONS = [Sparkles, Code2, Coins, Flag];

export const WhyUs = () => {
  const { t } = useLang();
  return (
    <section id="why-us" data-testid="why-us-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-4xl">
          <p className="font-mono2 text-xs uppercase tracking-[0.28em] text-emerald-400">{t.why.kicker}</p>
          <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">
            <span className="text-gradient">{t.why.title}</span>
          </h2>
        </Reveal>
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {t.why.pillars.map((p, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`why-pillar-${i}`}
                  className="glass group h-full rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-500/35"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-700/70 bg-slate-900/70 transition-colors group-hover:border-cyan-500/40">
                    <Icon className="h-5 w-5 text-cyan-400" />
                  </span>
                  <h3 className="font-display mt-5 text-lg font-bold tracking-tight text-slate-100">{p.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{p.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
